import React, { Component } from 'react';
import PracticeListRoot from './PracticeListRoot'
import DisplayNumber from './containers/DisplayNumber'
import { Link, Route, Switch, BrowserRouter as Router } from "react-router-dom"
import { Layout, Menu, Breadcrumb, Col, Row } from 'antd';
import { Button,  Progress, Table, Tag, Space } from 'antd';
import { Typography } from 'antd';
import ListPage from './ListPage'
import LoginForm from './LoginForm'
import Prestudent from './Prestudent'
import MyPage from './MyPage'
import store from './store'
import ProfList from './ProfList'
import StudentList from './StudentList'
const { Title } = Typography;
const { Header, Content, Footer } = Layout;


export default class MainPage extends Component{
  state={
    token: window.localStorage.getItem('session_token'),
    user_type:''
  }
  componentWillMount() {

  }

  render(){
    // let session_token = store.get('session_token')
    // let session_token = null
    if (this.props.token == undefined){
      return (
        <LoginForm/>
      )
    } else {

      if (this.props.session.role == 'student') {
        return (<MyPage/>)
      } else if (this.props.session.role == 'prestudent' || this.props.session.role == 'preprofessor'){
        return (<Prestudent/>)
      } else if (this.props.session.role == 'professor'){
        return (<ProfList match={{params:{state:'waiting'}}}/>)
      } else if (this.props.session.role == 'admin'){
        return (<StudentList match={{params:{state:'waiting'}}}/>)
      } else {
        return (<LoginForm/>)
      }
    }

  }
}